<template>
  <ul class="pause">
    <li @click="addnote(640, false)" :class="{disabled: !allowedInput(640)}"><img src="../../../assets/btn/2-tri_off.png" width="60" height="60" /></li>
    <li @click="addnote(320, false)" :class="{disabled: !allowedInput(320)}"><img src="../../../assets/btn/1-tri_off.png" width="60" height="60" /></li>
    <li @click="addnote(160, false)" :class="{disabled: !allowedInput(160)}"><img src="../../../assets/btn/05-tri_off.png" width="60" height="60" /></li>
  </ul>
</template>

<script>
export default {
  name: 'triplet_pause',
  computed: {
    lastNoteEnds: function(){
      return this.$store.getters.lastNoteEnds;
    },
    beats: function(){
      return this.$store.state.beats;
    }
  },
  methods: {
    allowedInput: function (length) {
      return (960*this.beats - this.lastNoteEnds) % length === 0
    },
    addnote: function (length, bool) {
      if (this.allowedInput(length)) {
        this.$emit('setnote', {'length': length, 'bool': bool});
      }
    }
  }
}
</script>

<style scoped>
.disabled{
  opacity: 0.5;
  background-color: #ddd;
}
</style>